
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "BaseButton",
  inheritAttrs: false,
})
export default class BaseButton extends Vue {
  @Prop({ default: false }) readonly title!: string;

  @Prop({ default: false }) readonly isNotDefault!: boolean;

  @Prop({ default: false }) readonly isMobile!: boolean;

  @Prop({ default: false }) readonly isEditButton!: boolean;
}
